
$(document).ready(function(){
  $('.selected-country-block').click(function() {
    $(this).toggleClass('active');
    $('.country-select-dropdown-block').toggle();
    $('body').toggleClass('country-select-open');
    return false;
  });
});

document.addEventListener('DOMContentLoaded', function() {

var selectionLinks = document.querySelectorAll('#country-selector a.Europe');
var currentUrl = new URL(window.location.href);
var countryParam = currentUrl.searchParams.get('country');
var languageParam = currentUrl.searchParams.get('language');

selectionLinks.forEach(function(link) {
  var linkCountry = link.dataset.country;
  var linkLanguage = link.dataset.language;

  if (linkCountry === countryParam && linkLanguage === languageParam) {
    link.classList.add('selected');
  }

  // Set the href attribute with the current URL, including existing pathname and parameters
  var newUrl = new URL(currentUrl);
  newUrl.searchParams.set('country', linkCountry);
  newUrl.searchParams.set('language', linkLanguage);
  

  if (!newUrl.hash.includes('redirectoff')) {
    link.href = newUrl.toString() + '#redirectoff';
  } else {
    link.href = newUrl.toString();
  }


  link.addEventListener('click', function(event) {
    event.preventDefault();
    window.location.href = link.href;
  });
});


var child = document.getElementById('country-selector-desktop');
var parent2 = document.getElementById('country-selector-mobile');

var clone = child.cloneNode(true);
parent2.appendChild(clone);

});